<template>
  <div  id='cust_component' class="cust_popover container-fluid">

    <div class="row">

        <div class="p-4 col-10 popover_content mx-auto d-none">

            <h4>
                <img class="pull-right point_cursor" src="../../assets/customer/images/close_icon.svg">
            </h4>

            <h5 class="mt-4 text-center"><b>Sorry ! Time out</b></h5>

            <p class="font-20 text-center my-3">Looks like one of the service/product you selected is not avaialble or already booked by someone else. continue to proceed or close to go back to choose again.</p>

        
            <div class="row">
                <div class="col-12">
                    <hr>
                </div>

                <div class="col-12">
                    <div class="row mt-3">
                        <div class="col-6">
                            <button type="button" class="btn btn-lg btn-block btn-ash btn-rounded btn_ash_shadow"><b>Close</b></button>
                        </div>
                        <div class="col-6">
                            <button type="button" class="btn btn-lg btn-block btn-pink btn-rounded">Continue</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="p-4 col-10 popover_content mx-auto" :class="this.$store.state.mobile_view ? '' : 'wide_popover'" v-if="popup_type == 'block_customer_popup'" >
           
            <h4>
                Something went wrong
                <img class="pull-right point_cursor" src="../../assets/customer/images/close_icon.svg" @click="closePopOver">
            </h4>

            <hr>

            <p class="font-20 text-center my-3">Unable to book online We faced an issue while processing your booking. Please call the salon directly to book.</p>

              <div class="col-12">
                <div class="row mt-3"  v-if='this.$store.state.mobile_view'>
                    <div class="col-6" >
                        <button type="button" class="btn btn-lg btn-block btn-ash btn-rounded btn_ash_shadow mt-3" @click="closePopOver"><b>Close</b></button>
                    </div>
                    
                    <div class="col-6">
                        <a :href=" 'tel:+' + store_mobile_number"><button type="button" class="btn btn-lg btn-block btn-green btn-rounded">
                            <img src="../../assets/customer/images/phone_white_icon.svg">
                            Call Now
                        </button></a>
                    </div>
                </div>
                <div class='row' v-else>
                    <div class="col-12 text-center">
                        <h5 class='m-0 text-center'><b>Phone: </b>{{store_mobile_number}}</h5>   
                    </div>
                        <div class="col-6 m-auto">
                        <button type="button" class="btn btn-lg btn-block btn-ash btn-rounded btn_ash_shadow mt-3" @click="closePopOver"><b>Close</b></button>
                    </div>
                </div>
                
            </div>


        </div>

        <div class="p-4 col-10 popover_content mx-auto"  :class="this.$store.state.mobile_view ? '' : 'wide_popover'" v-if="popup_type == 'multi_book_reschedule_popup'">


            <h4>
                Attention
                <img class="pull-right point_cursor" @click="closePopOver" src="../../assets/customer/images/close_icon.svg">
            </h4>

            <hr class="mt-0">

            <p class="font-20 text-center my-3">To reschedule this booking, please contact the salon directly.</p>

        
            <div class="col-12">
                <div class="row mt-3"  v-if='this.$store.state.mobile_view'>
                    <div class="col-6" >
                        <button type="button" class="btn btn-md btn-block btn-ash btn-rounded h-100" @click="closePopOver"><b>Close</b></button>
                    </div>
                    
                    <div class="col-6">
                        <a :href=" 'tel:+' + store_mobile_number"><button type="button" class="btn btn-lg btn-block btn-green btn-rounded">
                            <img src="../../assets/customer/images/phone_white_icon.svg">
                            Call Now
                        </button></a>
                    </div>
                </div>
                <div class='row' v-else>
                    <div class="col-12 text-center">
                        <h5 class='mb-3'><b>Phone: </b>{{store_mobile_number}}</h5>   
                    </div>
                        <div class="col-6 m-auto">
                        <button type="button" @click="closePopOver" class="btn btn-lg btn-block btn-ash btn-rounded" >Close</button>
                    </div>
                </div>
                
            </div>

        </div>

        <div class="p-4 col-10 popover_content mx-auto" v-if="popup_type =='slots_not_available'">

            <h5>
                Few cart items not available
                <img class="pull-right point_cursor" @click="closePopOver" src="../../assets/customer/images/close_icon.svg">
                
            </h5>

            <hr class="mt-0">

            <div class="row">
                <div class="col-12 text-center">
                    
                    <p class="mt-1">Few cart items are not available or were just booked by someone else. Please click edit below to select another product or service slot.</p>

                    <button type="button" class="btn btn-lg btn-ash btn-rounded w-50" @click="edit_function"><b>Edit</b></button>
                </div>

            </div>

        </div>

        <div class="p-4 col-10 popover_content mx-auto" v-if="popup_type =='payment_failed'">

            <h4>
                Payment failed
                <img class="pull-right point_cursor" @click="closePopOver" src="../../assets/customer/images/close_icon.svg">
            </h4>

            <hr class="mt-0">

            <div class="row">
                <div class="col-12 text-center">
                    
                    <p class="mt-1">Your payment has been failed due to some error please try again to pay or close.</p>

                    <button type="button"  @click="closePopOver"  class="btn btn-lg btn-ash btn-rounded w-50"><b>Close</b></button>
                </div>

            </div>

        </div>

        <div class="p-3 col-9 popover_content  mx-auto" v-if="popup_type == 'success_popup'">

            <h4 class="green">
                Booking Successful!
                <img @click="closePopOver" class="pull-right point_cursor" src="../../assets/customer/images/close_icon.svg">
            </h4>

            <hr class="mt-0">

            <div class="row">
                <div class="col-12 text-center">
                    <img src="../../assets/customer/images/success_img.svg">
                    <p class="mt-3"><b>Congratulations {{cust_name}}</b></p>
                    <p class="mt-3">We look forward to seeing you soon </p>
                    <hr>
                    <button type="button" @click="closePopOver" class="btn btn-lg btn-block btn-ash btn-rounded">Close</button>
                </div>
            </div>

        </div>

        <div class="p-4 col-10 popover_content mx-auto" v-if="popup_type == 'remove_cart_service_popup'">

            <p>
                <b>Remove Service</b>
                <img class="pull-right point_cursor" @click="closePopOver" src="../../assets/customer/images/close_icon.svg">
            </p>

            <hr class="mt-0">

            <div class="row">
                <div class="col-12 text-center">
                    <p class="mt-1">Are you sure you want to remove this service from your cart?</p>
                </div>

                <div class="col-12">
                    <div class="row mt-3">
                        <div class="col-6">
                            <button type="button" class="btn btn-md btn-block btn-ash btn-rounded h-100" @click="closePopOver"><b>Close</b></button>
                        </div>
                        <div class="col-6">
                            <button type="button" class="btn btn-md btn-block btn-pink btn-rounded h-100" @click="continueFunction">Remove</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="p-3 col-10 popover_content mx-auto" v-if="popup_type == 'cancel_booking_popup'">
            
            <p>
                <b>Cancel Booking </b>
                <img class="pull-right point_cursor" @click="closePopOver" src="../../assets/customer/images/close_icon.svg">
            </p>

            <hr class="mt-0">

            <div class="row">
                <div class="col-12">
                    <p class="mt-1 ash">Please note, if you cancel this booking, you will need to create a new one. Any payments made will be credited to your wallet to use in your next booking. </p>
                </div>

                <div class="col-8 m-auto">
                    <button type="button" class="btn btn-lg btn-block btn-red btn-rounded h-100" @click="continueFunction">Cancel My Booking</button>
                </div>
            </div>

        </div>

        <div class="p-3 col-10 popover_content mx-auto" v-if="popup_type == 'cancel_single_booking_popup'">
            
            <p>
                <b>Cancel booking</b>
                <img class="pull-right point_cursor" @click="closePopOver" src="../../assets/customer/images/close_icon.svg">
            </p>

            <hr class="mt-0">

            <div class="row">
                <div class="col-12">
                    <p class="mt-1 ash">Note that once cancelled it cannot be undone and the amount will be credited in your app as wallet balance to use for future bookings. </p>
                </div>
                 
                  <div class="col-12">
                    <div class="row mt-3">
                        <div class="col-6">
                            <button type="button" class="btn btn-md btn-block btn-ash btn-rounded h-100" @click="rescheduleFunction"><b>Reschedule</b></button>
                        </div>
                        <div class="col-6">
                            <button type="button" class="btn btn-md btn-block btn-pink btn-rounded h-100" @click="continueFunction">Cancel</button>
                        </div>
                    </div>
                </div>
                
            </div>

        </div>

        <div class="p-3 col-10 popover_content mx-auto" v-if="popup_type == 'before_24hrs_popup'">
            
            <p>
                <b>Cancel Booking </b>
                <img class="pull-right point_cursor" @click="closePopOver" src="../../assets/customer/images/close_icon.svg">
            </p>

            <hr class="mt-0">

            <div class="row">
                <div class="col-12">
                    <p class="mt-1 ash">You cannot cancel booking before 24hrs of your service start time, Please contact our salon to know more or cancel booking. </p>
                    
                </div>
                 
                <div class="col-12">
                    <div class="row mt-3"  v-if='this.$store.state.mobile_view'>
                        <div class="col-6" >
                            <button type="button" class="btn btn-md btn-block btn-ash btn-rounded h-100" @click="closePopOver"><b>Close</b></button>
                        </div>
                        
                        <div class="col-6">
                            <a :href=" 'tel:+' + store_mobile_number"><button type="button" class="btn btn-lg btn-block btn-green btn-rounded">
                                <img src="../../assets/customer/images/phone_white_icon.svg">
                                Call Now
                            </button></a>
                        </div>
                    </div>
                    <div class='row' v-else>
                        <div class="col-12 text-center">
                            <h5 class='mb-3'><b>Phone: </b>{{store_mobile_number}}</h5>   
                        </div>
                         <div class="col-6 m-auto">
                            <button type="button" @click="closePopOver" class="btn btn-lg btn-block btn-ash btn-rounded" >Close</button>
                        </div>
                    </div>
                    
                </div>
                
            </div>

        </div>


        <div class="p-3 col-10 popover_content mx-auto" :class="this.$store.state.mobile_view ? '' : 'wide_popover'" v-if="popup_type == 'before_24hrs_reschedule_popup'">
            
            <p>
                <b>Reschedule Booking </b>
                <img class="pull-right point_cursor" @click="closePopOver" src="../../assets/customer/images/close_icon.svg">
            </p>

            <hr class="mt-0">

            <div class="row">
                <div class="col-12">
                    <p class="mt-1 ash">You cannot reschedule booking before 24hrs of your service start time, Please contact our salon to know more or reschedule booking. </p>
                    
                </div>
                 
                <div class="col-12">
                    <div class="row mt-3"  v-if='this.$store.state.mobile_view'>
                        <div class="col-6" >
                            <button type="button" class="btn btn-md btn-block btn-ash btn-rounded h-100" @click="closePopOver"><b>Close</b></button>
                        </div>
                        
                        <div class="col-6">
                            <a :href=" 'tel:+' + store_mobile_number"><button type="button" class="btn btn-lg btn-block btn-green btn-rounded">
                                <img src="../../assets/customer/images/phone_white_icon.svg">
                                Call Now
                            </button></a>
                        </div>
                    </div>
                    <div class='row' v-else>
                        <div class="col-12 text-center">
                            <h5 class='mb-3'><b>Phone: </b>{{store_mobile_number}}</h5>   
                        </div>
                         <div class="col-6 m-auto">
                            <button type="button" @click="closePopOver" class="btn btn-lg btn-block btn-ash btn-rounded" >Close</button>
                        </div>
                    </div>
                    
                </div>
                
            </div>

        </div>

        <div class="p-3 col-10 popover_content mx-auto" v-if="popup_type == 'cancelled_booking_popup'">

            <p>
                <b>Cancelled</b>
                <img class="pull-right point_cursor" @click="continueFunction" src="../../assets/customer/images/close_icon.svg">
            </p>


            <div class="row">
                <div class="col-12 text-center">
                    <img height="80" width="80" src="../../assets/images/icons/booking_completed.svg">
                     <p class="mt-1 ash">Your booking with the ID #{{cancelled_book_id}} cancelled successfully. Refund will be processed as per the Salon Refund Policy. We are waiting to see you soon again. </p>
                </div>

                <div class="col-8 m-auto">
                    <button type="button" class="btn btn-lg btn-block btn-pink btn-rounded h-100" @click="continueFunction"><b>Home</b></button>
                </div>
            </div>

        </div>

        <div class="p-3 col-10 popover_content mx-auto" v-if ="popup_type == 'store_popup'">

            <h4>
                <img class="pull-right point_cursor" src="../../assets/customer/images/close_icon.svg"  @click="closePopOver">
            </h4>

            <h5 class="mt-4"><b>Please Confirm</b></h5>

            <hr>

            <p class="font-20 text-center my-3">Looks like you are trying to access another store, do you want to discard cart from current store and continue? </p>

            <div class="row">

                <div class="col-12">
                    <div class="row mt-3">
                        <div class="col-6">
                            <button type="button" class="btn btn-lg btn-block btn-ash btn-rounded btn_ash_shadow"  @click="closePopOver"><b>Close</b></button>
                        </div>
                        <div class="col-6">
                            <button type="button" class="btn btn-lg btn-block btn-pink btn-rounded" @click="continueFunction">Continue</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="p-3 col-10 popover_content mx-auto" v-if="popup_type == 'network_error_popup'">

            <p>
                <b>Network Error</b>
            </p>

            <div class="row">
                <div class="col-12 text-center">
                    <p class="mt-1 ash">It seems like you are on a very slow/no network. Please try again later.</p>
                </div>

                <div class="col-8 m-auto">
                    <button type="button" class="btn btn-sm btn-block btn-pink btn-rounded h-100" @click="continueFunction"><b>Close</b></button>
                </div>
            </div>

        </div>
        
    </div>
    
  </div>
</template>

<script>
export default {
    name: 'popover',
    data(){
        return {
        }
    },
    props: {
        store_mobile_number : String,
        popup_type : String,
        cancelled_book_id : Number,
        cust_name :String
    },
    methods:{
        closePopOver(){
            this.$emit('closePopUp');
        },

        continueFunction(){
            this.$emit('continueFunction');
        },

        edit_function(){
            this.$emit('editFunction');
        },

        rescheduleFunction(){
            this.$emit('bookingReschedule'); 
        }

    }
}
</script>

<style scoped>
    .cust_popover{
        position: fixed;
        z-index: 2000;
        top:0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0,0,0,0.4) !important;
    }

    .popover_content{
        background: #ffffff;
        border-radius: 6px;
        max-width : 350px;
        position: fixed;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

    .wide_popover{
        max-width: 400px !important;
    }
</style>
